import React, { useMemo, useRef } from 'react'

export default function SwerveLine({ completed, className, children, ...rest }) {
    const pathRef = useRef()
    const length = useMemo(() => pathRef?.current?.getTotalLength(), [pathRef?.current])

    const cappedCompleted = Math.min(completed, 1)

    return (
        <div className={className + ' relative'} {...rest}>
            <svg className={'w-full h-screen'} viewBox="0 0 1777 866" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                <path ref={pathRef}
                    d="M-43 12C111 227 367.5 541 672 541C962.558 541 1130.5 169 1395 355C1606.6 503.8 1907.5 896.333 2031.5 1074"
                    stroke="#363636" stroke-width="17" stroke-dasharray={length}
                    stroke-dashoffset={(length * (1 - cappedCompleted))} stroke-linecap="square" />
            </svg>
            {children}
        </div>
    )
}

export function VerticalSwerveLine({ completed, className, children, ...rest }) {
    return <div className={className + ' relative overflow-hidden'} {...rest}>
        <svg className='' style={{ width: '105%', marginLeft: '-2.5%' }} preserveAspectRatio="none" width="476" height="1162" viewBox="0 0 476 1162" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 12C38.6667 48.4521 98.3835 172.274 90 373.954C79.5 626.552 36.5 811.543 76 922.44C127.275 1066.39 330.5 1117.34 465 1151" stroke="#363636" stroke-width="17" stroke-linecap="square" />
        </svg>
        {children}
    </div>

}
